import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { getBgColorAprovacao } from '../../pages/Processo/components/ColorsAnalise';
import { AnaliseStatusIcon } from './AnaliseStatusIcon';
export var AnaliseGrupoStatusComponent = function (_a) {
    var _b;
    var analise = _a.analise, entidade = _a.entidade, entidadeAssociadaId = _a.entidadeAssociadaId, grupo = _a.grupo, children = _a.children;
    var analiseItem = (_b = analise === null || analise === void 0 ? void 0 : analise.gruposCampos) === null || _b === void 0 ? void 0 : _b.find(function (a) {
        return a.entidade === entidade &&
            a.entidadeAssociadaId === entidadeAssociadaId &&
            a.grupo === grupo;
    });
    if (!analise || !entidadeAssociadaId || !analiseItem) {
        return children;
    }
    return (_jsx(Box, { sx: {
            borderRadius: 2,
            padding: 2,
            backgroundColor: getBgColorAprovacao(analiseItem === null || analiseItem === void 0 ? void 0 : analiseItem.status),
        }, children: _jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
            }, children: [_jsx(Box, { sx: {
                        mr: 2,
                    }, children: _jsx(AnaliseStatusIcon, { status: analiseItem === null || analiseItem === void 0 ? void 0 : analiseItem.status }) }), _jsxs(Stack, { sx: {
                        flexGrow: 1,
                        p: 1,
                        borderRadius: 1,
                        border: '1px solid #E4E4E4',
                        bgcolor: '#F5F5F5',
                    }, children: [_jsx(Box, { children: children }), (analiseItem === null || analiseItem === void 0 ? void 0 : analiseItem.justificativa) && (_jsxs(Box, { sx: { mt: 2 }, children: [_jsx(Typography, { variant: "caption", color: "textSecondary", children: "Motivo da reprova\u00E7\u00E3o:" }), _jsx(Box, { sx: {
                                        border: '1px solid rgba(0, 0, 0, 0.38)',
                                        borderRadius: 1,
                                        px: 2,
                                        py: 1,
                                        whiteSpace: 'pre-wrap',
                                        overflowX: 'auto',
                                        overflowY: 'auto',
                                        minHeight: '100px',
                                        height: '100px',
                                        maxHeight: '500px',
                                        resize: 'vertical',
                                        color: 'text.secondary',
                                    }, children: analiseItem === null || analiseItem === void 0 ? void 0 : analiseItem.justificativa })] }))] })] }) }));
};
